import React from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';

/**
 * @typedef {import('../../App.d.ts').ComponentErrorPageProps} ComponentErrorPageProps
 */
/**
 *
 * @param {ComponentErrorPageProps} props
 */
export default ({
  // @deprecated
  goBackText,
  headline,
  info,
  actionText,
  actionUrl,
  imageUrl,
  tip,
}) => (
  <Container>
    <div
      data-testid="error-page"
      className="dodo-error-page"
    >
      <h1>{headline}</h1>
      <p>{info}</p>
      {goBackText || actionText || actionUrl ? (
        <div className="dodo-error-page__actions">
          <Button
            mode={Button.modes.PRIMARY}
            text={actionText || goBackText}
            onClick={() => {
              location.href = actionUrl ?? '/';
            }}
          />
        </div>
      ) : null}
      {imageUrl && (
        <img
          src={imageUrl}
          alt=""
        />
      )}
      {tip && (
        <div className="dodo-error-page__tip-box">
          <IconAsChunk iconName="Lightbulb" />
          <p>{tip}</p>
        </div>
      )}
    </div>
  </Container>
);
